import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoggerService } from './logger.service';
import { TaggedLogger } from './taggedLogger';
import { IVehicleAddress, IVehicleLastDropOffAddress } from '../interfaces/task-info';
import { PcaRetrieveResult } from './pca.service';

export class ManualSearchAddress {
  BusinessName: string;
  Line1: string;
  Line2: string;
  Line3: string;
  City: string;
  PostalCode: string;
  What3Words: string;
}

@Injectable({ providedIn: 'root' })
export class VehicleAddressService {
  private logger: TaggedLogger;

  baseUrl = 'api/VehicleAddress';

  constructor(public http: HttpClient, loggerService: LoggerService) {
    this.logger = loggerService.taggedLogger('VehicleAddressService');
  }

  public GetFromCoord(lat: number, lng: number) {
    return this.http
      .get<IVehicleAddress>(`${this.baseUrl}/reverseGeocode?lat=${lat}&lng=${lng}`)
      .toPromise();
  }

  public GetVehicleAddress(address: string) {
    const encodedAddress = encodeURIComponent(address);
    return this.http
      .get<IVehicleAddress>(`${this.baseUrl}/geocode?address=${encodedAddress}`)
      .toPromise();
  }

  public GetFromPcaAddress(address: PcaRetrieveResult) {
    return this.http.post<IVehicleAddress>(`${this.baseUrl}/fromPcaAddress`, address).toPromise();
  }

  public GetFromManualEntry(address: ManualSearchAddress) {
    return this.http.post<IVehicleAddress>(`${this.baseUrl}/fromManualEntry`, address).toPromise();
  }

  public calculateDistance(lon1, lat1, lon2, lat2) {
    var R = 6371; // Radius of the earth in km
    var dLat = this.toRadians(lat2 - lat1);
    var dLon = this.toRadians(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.toRadians(lat1)) *
        Math.cos(this.toRadians(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
  }

  public toRadians(coordDiff: number) {
    return (coordDiff * Math.PI) / 180;
  }

  public getLastDropOffAddressForVehicleReg(vehicleReg: string): Promise<any> {
    return this.http
      .get<IVehicleLastDropOffAddress>(
        `${this.baseUrl}/getLastDropOffAddressForVehicleReg?vehicleReg=${encodeURIComponent(
          vehicleReg,
        )}`,
      )
      .toPromise();
  }
}
